import GuarantyOfferFormComponent from "../../components/guaranty/GuarantyOfferFormComponent"
import { IGarantie, IOffersDetails } from "../../context/model";

type GuarantyOfferBlocProps = {
    handleSwitchPage: () => void;
    garanties: IGarantie[]
    options: Record<string, IOffersDetails | null>
}

export default function GuarantyOfferBloc({handleSwitchPage, garanties, options} : Readonly<GuarantyOfferBlocProps>) {

      return (
        <div className="">
          <div className="">
            <h2 className="ta-center m-y-sm card-title bleu">Renforcez votre garantie avec l'une des options suivantes</h2>
            <GuarantyOfferFormComponent handleSwitchPage={handleSwitchPage} garanties={garanties} options={options}/>
          </div>
        </div>
      )
}